

exports.__esModule = true;
exports.$LandingRoute = void 0;
var _angular = require("angular");
var _squid = require("squid");
var _logger = require("xo-beaver/dist/logger");
var _index = require("xo-models/src/user/index");
var _index2 = require("xo-models/src/checkout/index");
var _index3 = require("xo-models/src/inventory/index");
var _helper = require("./helper");
var $LandingRoute = exports.$LandingRoute = _squid.$ComponentRoute.extend('LandingRoute', {
  name: 'landing',
  // Uncomment the following line to suffix content to
  // the title of the page
  // Base title is 'PayPal Checkout'
  // titleContent: 'accountCreationGuest.heading',

  scope: {
    isUnbranded: '=?'
  },
  trackingData: {
    fptiState: 'landing',
    trackStateExit: true
  },
  init: function init() {
    this._super.init.apply(this);
    _squid.$event.on('countryChange', function () {
      _index2.$FlowEligibilityModel.instance(_angular.$rootScope.token).invalidate();
    });
  },
  resolve: {
    action: function action() {
      var models = {};
      return (0, _squid.$populate)(models, {
        checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token),
        checkoutPayeeModel: _index2.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
        checkoutAppData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
        checkoutInputData: _index.$CheckoutInputDataModel.instance(_angular.$rootScope.token)
      }).then(function () {
        // C2 ramp - force CN country code to C2 upon landing
        if (_squid.$locale.country === 'CN') {
          _squid.$locale.change('C2', _squid.$locale.lang);
          _logger.$logger.info('CN_locale_forced_to_C2');
        }
      }).then(function () {
        if (_squid.$util.param('atoSuccess')) {
          _logger.$logger.info('Guest_authflow_successful_redirection_from_ANW');
          return 'checkout.guestauthnode';
        }
        var cartHasInventory = models.checkoutCart.get('cartHasInventory');
        if (_squid.$config.enableInventoryWPS && cartHasInventory) {
          var inventoryModel = _index3.$InventoryModel.instance(_angular.$rootScope.token);
          var inventoryInput = {
            items: models.checkoutCart.get('purchase.items'),
            merchantId: models.checkoutPayeeModel.getId()
          };
          return inventoryModel.action('getInventory', {
            data: inventoryInput,
            success: function success(inventoryResponse) {
              if (inventoryResponse.showSoldoutPage) {
                return {
                  to: 'checkout.soldout',
                  params: {
                    items: encodeURIComponent(inventoryResponse.soldoutItems),
                    soldOutUrl: encodeURIComponent(inventoryResponse.soldoutUrl)
                  }
                };
              } else {
                inventoryModel.setInvetoryItems(inventoryResponse);
                return _helper.landingPageResolver.landingFlow(models);
              }
            }
          });
        } else {
          return _helper.landingPageResolver.landingFlow(models);
        }
      });
    }
  }
});
angular.value("$LandingRoute", $LandingRoute);
_angular.$rootScope;
_squid.$ComponentRoute;
_squid.$config;
_squid.$event;
_squid.$util;
_squid.$locale;
_squid.$populate;
_logger.$logger;
_index.$CheckoutInputDataModel;
_index2.$CheckoutAppDataModel;
_index2.$CheckoutPayeeModel;
_index2.$CheckoutCartModel;
_index2.$FlowEligibilityModel;
_index3.$InventoryModel;
_helper.landingPageResolver;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-landing/route.js
// module id = ./pages/xo-landing/route.js
// module chunks = 0